import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { CoreUiPartialState, getBranch, getCustomerOrderDetailsForTask, getUserId, saveCustomerOrderDetailsForTask } from '@pos-app/core-ui';
import { CustomersPartialState } from 'apps/pos-app/src/app/features/customers/+state/customers.reducer';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Location } from '@angular/common';
import { CentralPartialState } from '../../../../+state/central.reducer';
import { SaveActiveNavIndex } from '../../../../+state/central.actions';

@Component({
  selector: 'app-task-nav',
  styleUrls: ['./task-nav.component.scss'],
  templateUrl: './task-nav.component.html',
})
export class TaskNavComponent implements OnInit {
  @Input() activeNavIndex: number = 0;
  raisedBy$: Observable<string>;
  sourceSite$: Observable<string>;
  private unSubscribe$ = new Subject<void>();
  orderDetails: any;

  constructor(
    private coreUIStore: Store<CoreUiPartialState>,
    private router: Router,
    private customerStore: Store<CustomersPartialState>,
    private location: Location,
    private store: Store<CentralPartialState>
  ) {}

  ngOnInit() {}
  setActiveNav(index: any) {
    this.activeNavIndex = index;
    if (index === 0) {
      this.router.navigate(['/central/tasks']);
    }
    if (index === 1) {
      this.coreUIStore.dispatch(saveCustomerOrderDetailsForTask({ customerOrderDetails: { newTask: true } }));
      this.router.navigate(['/central/task/new']);
    }
    if (index === 2) {
      this.router.navigate(['/central/tasks/closed']);
    }
    if (index === 3) {
      this.location.back();
    }
  }

  goToPreviousScreen() {
    this.store.dispatch(new SaveActiveNavIndex(0));
    if (this.router.url === '/central/tasks') {
      this.router.navigate(['/central']);
    } else {
      window.history.back();
    }
  }
}
